export default {
  title: 'パスワード再設定',
  subtitle: 'Global Hubに登録中のメールアドレスを入力してください',
  submitButton: '次へ',
  placeholder: '入力してください',
  successTitle: 'パスワード再設定用の\nメールを送信しました。',
  successDescription: '登録のメールアドレス{email}にパスワード再設定用のメールを送信しました。メールをご確認の上、記載された手順に従って再設定を行ってください。',
  backToLogin: 'ログイン画面に戻る',
  loading: '送信中...',
  sendFailed: 'メールアドレスが存在しません。',
};